import { get } from 'lodash';

export const getTemplates = state =>
  get(state, 'LetterSetupState.setup.templates', []);

export const getFetching = state =>
  get(state, 'LetterSetupState.setup.fetching');

export const getTemplate = (state, templateId) => {
  const templates = getTemplates(state);
  return templates.find(t => t.Id === templateId);
};

export const getTemplateLetterCustom = (state, templateId) => {
  const template = getTemplate(state, templateId);
  return get(template, 'LetterCustom', []);
};

export const getLetterCustom = (state, templateId, letterCustomId) => {
  const template = getTemplate(state, templateId);
  if (!template) return null;
  const LetterCustom = get(template, 'LetterCustom', []);
  if (letterCustomId) {
    return LetterCustom.find(lc => lc.Id === letterCustomId);
  }
  return LetterCustom;
};

export const getTemplateTokens = (state, templateId) =>
  get(getTemplate(state, templateId), 'Tokens', []);

export const getPreview = state => get(state, 'LetterSetupState.setup.preview');

export const getPreviewLoading = state =>
  get(state, 'LetterSetupState.setup.previewFetching', false);



// WEBPACK FOOTER //
// ./src/pages/lettersetup/state/selectors.js